import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PosSessionContextType {
  activeStaffId: string | null;
  setActiveStaffId: (id: string | null) => void;
  lockScreen: () => void;
}

const PosSessionContext = createContext<PosSessionContextType>({
  activeStaffId: null,
  setActiveStaffId: () => {},
  lockScreen: () => {}
});

export const usePosSession = () => useContext(PosSessionContext);

export const PosSessionProvider = ({ children }: { children: ReactNode }) => {
  const [activeStaffId, setActiveStaffId] = useState<string | null>(() => {
    return sessionStorage.getItem('posActiveStaffId') || null;
  });

  const setStaff = (id: string | null) => {
    setActiveStaffId(id);
    if (id) {
      sessionStorage.setItem('posActiveStaffId', id);
    } else {
      sessionStorage.removeItem('posActiveStaffId');
      sessionStorage.removeItem('posActiveStaffName');
    }
  };

  const lockScreen = () => setStaff(null);

  return (
    <PosSessionContext.Provider value={{ activeStaffId, setActiveStaffId: setStaff, lockScreen }}>
      {children}
    </PosSessionContext.Provider>
  );
};
